import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../Apis/apiConfig";
import { Save, Building2,FileText, Percent, Loader2,
} from "lucide-react";
import "../Style/Interest.css";
import { useNavigate } from "react-router-dom";

const Interest = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // const [formData, setFormData] = useState({
  //   societyName: "",
  //   registrationNo: "",
  //   interestRate: "",
  // });

 const [formData, setFormData] = useState({
  societyName: "",
  registrationNo: "",
  interestRate: "",
  interestType: "MONTH",
});

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
  try {
    setLoading(true);

    const token = localStorage.getItem("token");

    const formDataEncoded = new URLSearchParams();

    formDataEncoded.append(
      "societyName",
      localStorage.getItem("society") || ""
    );

    formDataEncoded.append(
      "registrationNo",
      localStorage.getItem("societyRegNo") || ""
    );

    formDataEncoded.append("interestRate", formData.interestRate);
    
    formDataEncoded.append("interestType", formData.interestType);

    const response = await fetch(`${BASE_URL}/api/interest/add-interest`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      body: formDataEncoded,
    });

    const data = await response.text();

    if (response.ok) {
      toast.success(data || "Interest Added Successfully");

      setFormData({
        societyName: "",
        registrationNo: "",
        interestRate: "",
      });
    } else {
      toast.error("Failed To Save Record");
    }
  } catch (error) {
    toast.error("Internal Server Error");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="interest-page">
            <div className="interest-card">

              {/* HEADER */}
              <div className="card-header">
                <div>
                <h2 style={{ color: "#2563eb" }}>Add Interest</h2>
                  <p>Create and manage society interest details</p>
                </div>

              <div
  className="header-badge"
  style={{ cursor: "pointer" }}
  onClick={() => navigate("/all-interest")}
>
  Interest Setup
</div>
              </div>

              {/* FORM */}
              <div className="form-grid">

                <div className="input-group">
                  <label>Society Name</label>
                  <div className="input-wrapper">
                    <Building2 size={18} className="input-icon" />
                    <input
                      name="societyName"
                      value={localStorage.getItem("society")}
                      onChange={handleChange}
                      placeholder="Enter Society Name"
                    />
                  </div>
                </div>

                <div className="input-group">
                  <label>Registration No</label>
                  <div className="input-wrapper">
                    <FileText size={18} className="input-icon" />
                    <input
                      name="registrationNo"
                      value={localStorage.getItem("societyRegNo")}
                      onChange={handleChange}
                      placeholder="Enter Registration Number"
                    />
                  </div>
                </div>
               <div className="form-grid">

                <div className="input-group">
                  <label>Late Payment Interest Rate</label>

                  <div className="input-wrapper">
                    <Percent size={18} className="input-icon" />

                    <input
                      type="number"
                      name="interestRate"
                      value={formData.interestRate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          interestRate: Math.max(0, e.target.value),
                        })
                      }
                      placeholder="Enter Interest Rate"
                    />
                  </div>
                </div>

                <div className="input-group">
                  <label>Interest Type</label>

                  <select
                    name="interestType"
                    value={formData.interestType}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        interestType: e.target.value,
                      })
                    }
                    className="interest-select"
                  >
                    <option value="DAY">Per Day</option>
                    <option value="MONTH">Per Month</option>
                  </select>
                </div>

              </div>
              
              </div>
        
              <div className="button-section">
                <button
                  className="save-btn"
                  onClick={handleSave}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Loader2 size={18} className="spin" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <Save size={18} />
                      Save Interest
                    </>
                  )}
                </button>
              </div>

            </div>
          </div>

          <ToastContainer />
        </main>
      </div>
    </div>
  );
};

export default Interest;